import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export default function ZoomImage({
  imageData, productId, altZoomImage, onImageLoad, onIsVisible, imageIndex, handleImageErrorOrRemoval,
}) {
  const { ref: zoomImageRef, inView: imageInView } = useInView();
  const {
    zoomImageSrc,
    imageId,
    type,
  } = imageData;

  useEffect(() => {
    if (imageInView) {
      onIsVisible(imageIndex);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageInView]);

  return (
    <img
      ref={zoomImageRef}
      data-testid="zoom-image"
      className="main-zoom-image"
      data-src={zoomImageSrc}
      data-collection={productId}
      alt={altZoomImage(type, imageId)}
      onLoad={onImageLoad}
      src={zoomImageSrc}
      onError={() => handleImageErrorOrRemoval(imageId)}
    />
  );
}
